// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

// Cache layout values to avoid forced reflow on every mousemove
let _cachedImageWidth = 0;
let _cachedRatio = 0;
let _cachedRect = null;

function moveWithHover(image, event, zoomRatio) {
  // Cache layout reads - only recalculate if image changed
  if (_cachedImageWidth !== image.clientWidth || !_cachedRect) {
    _cachedImageWidth = image.clientWidth;
    _cachedRatio = image.height / image.width;
    _cachedRect = event.target.getBoundingClientRect();
  }

  const xPosition = event.clientX - _cachedRect.left;
  const yPosition = event.clientY - _cachedRect.top;
  const xPercent = `${xPosition / (_cachedImageWidth / 100)}%`;
  const yPercent = `${yPosition / ((_cachedImageWidth * _cachedRatio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  // Pre-cache layout values here to avoid forced reflow on first mousemove
  _cachedImageWidth = image.clientWidth;
  _cachedRatio = image.height / image.width;
  _cachedRect = image.getBoundingClientRect();
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  // tw1: hover-magnify is a desktop-only affordance. On touch devices a tap would
  // create a giant full-size overlay that is awkward to dismiss (no close button),
  // so only bind it on hover-capable pointers.
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
